import EnhancedProductTemplate from "./enhanced-product-template";
import {
  CreditCard,
  Zap,
  FileText,
  DollarSign,
  BarChart3,
  Shield,
  RefreshCw,
  Eye,
} from "lucide-react";
import { useTranslation } from "../../../i18n";

export default function BillingSection() {
  const { t } = useTranslation();

  const features = [
    {
      title: t("routes.billing.section.features.0.title"),
      description: t("routes.billing.section.features.0.description"),
      icon: <Zap className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.1.title"),
      description: t("routes.billing.section.features.1.description"),
      icon: <CreditCard className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.2.title"),
      description: t("routes.billing.section.features.2.description"),
      icon: <FileText className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.3.title"),
      description: t("routes.billing.section.features.3.description"),
      icon: <DollarSign className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.4.title"),
      description: t("routes.billing.section.features.4.description"),
      icon: <BarChart3 className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.5.title"),
      description: t("routes.billing.section.features.5.description"),
      icon: <Shield className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.6.title"),
      description: t("routes.billing.section.features.6.description"),
      icon: <RefreshCw className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.billing.section.features.7.title"),
      description: t("routes.billing.section.features.7.description"),
      icon: <Eye className="h-4 w-4 text-white" />,
    },
  ];

  const stats = [
    {
      label: t("routes.billing.section.stats.supportedCurrencies"),
      value: "10+",
    },
    { label: t("routes.billing.section.stats.paymentMethods"), value: "20+" },
    { label: t("routes.billing.section.stats.supportCountries"), value: "40+" },
  ];

  return (
    <EnhancedProductTemplate
      logoSrc="/icons/billing.png"
      logoAlt={t("routes.billing.section.logoAlt")}
      title={t("routes.billing.section.title")}
      slogan={t("routes.billing.section.slogan")}
      description={t("routes.billing.section.description")}
      features={features}
      primaryCtaText={t("routes.billing.section.primaryCta")}
      primaryCtaLink="#cta"
      secondaryCtaText={t("routes.billing.section.secondaryCta")}
      secondaryCtaLink="https://docs.juhuu.app/articles/art_686ea8c49caa5236fbdcbaff"
      colorScheme="green"
      layout="default"
      showBadge={false}
      showStats={true}
      stats={stats}
      showTestimonial={false}
      showAnimation={true}
    />
  );
}
